import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavController } from '@ionic/angular';
import { TrackInfo } from 'src/app/shared/service/journey/tracks/model/track-info';
import { AnalyticsPageModel } from '../../../shared/model/analyticsPage';
import { RadioModel } from '../../../shared/model/radio.model';
import { DefaultPageComponent } from '../../../shared/page/default-page.component';
import { AnalyticsPageService } from '../../../shared/service/analytics/analytics-page.service';
import { AnalycticsNativeService } from '../../../shared/service/comunicator-native/analytics-native/analyctics-native';
import { BackNativeService } from '../../../shared/service/comunicator-native/back-native/back-native';
import { ReturnNativeService } from '../../../shared/service/comunicator-native/return-native/return-native';
import { DomainFactoryService } from "../../../shared/service/domains/domain-factory-service";
import { DomainDataType } from "../../../shared/service/domains/model/domain-data-type";
import { JourneyService } from '../../../shared/service/journey/journey.service';
import { ValueSort } from "../../../shared/sort-funcions/value-sort";
import { AddressService } from '../../services/address.service';

@Component({
  selector: 'app-address-state',
  templateUrl: './address-state.component.html',
  styleUrls: ['./address-state.component.scss'],
})
export class AddressStateComponent extends DefaultPageComponent implements OnInit {

  selectedItem = '';
  selectedName = '';
  state = new Array<RadioModel>();
  textSearch: string;
  fieldSearch = 'value';
  headerId = 'address-state';
  titlePage = 'Endereço';
  buttonEnable = false;
  @ViewChild('content') content: ElementRef;
  startStage = '';
  endStage = '';
  showRetry = false;
  loading = true;
  analyticsPage: AnalyticsPageModel;

  constructor(
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public router: NavController,
    public returnNativeService: ReturnNativeService,
    private title: Title,
    public analycticsNativeService: AnalycticsNativeService,
    private addressService: AddressService,
    private domainFactory: DomainFactoryService,
    private analyticsPageService: AnalyticsPageService,
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.configureDomain(null, DomainDataType.State);
    this.analyticsData();
    this.getTrack();
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.getDomainState();
    this.editFieldInvest('estado', 'state', 'address');
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = 'address';

    this.startStage = track.getIndexPage(this.headerId, path).toString();
    this.endStage = track.getTotalPage(path).toString();
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
  }

  ionViewDidLeave() {
    this.textSearch = '';
    this.state = this.orderList(this.state, this.selectedItem);
    this.ariaHidden = true;
  }

  analyticsData() {
    // tslint:disable-next-line:variable-name
    const it_pagename = this.analyticsPage.addressState;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  backPage() {
    this.analyticsEventClique();
    if (this.addressService.addressInitalPostCode?.district) {
        return this.router.navigateBack(['address', 'adjunt']);
    }

    return this.back();
  }

  clickNext() {
    this.addressService.setAddressStateName(this.selectedName);
    this.addressService.setAddressState(this.selectedItem);

    if (this.addressService.addressInitalPostCode?.city) {
      const track = this.journeyService.selectedTrack.getTrack();
      const indexAdressState = track.findIndex((page: TrackInfo) => page.pageId === 'address-city') + 1;
      const path = track[indexAdressState]?.path;

      if (path) {
        return this.router.navigateForward(path);
      } else {
        return this.endJourney();
      }
    }

    this.nextPage();
  }

  analyticsEventClique() {
    // tslint:disable-next-line:variable-name
    const it_eventcategory = 'Clique';
    // tslint:disable-next-line:variable-name
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.addressState
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(it_eventcategory, it_complementary);
  }

  getDomainState() {
    this.domainFactory.getDomainService(this.domainOrigin)
    .getDomains(this.domainDataType).then((dominios) => {
      if (dominios?.length > 0) {
        this.state = this.orderList(dominios, this.journeyService.registratioJourney.data.address?.state);
        this.showRetry = false;
      } else {
        this.showRetry = true;
        this.headerFocus();
      }
    }).catch((err) => {
      this.showRetry = true;
    }).finally(() => {
      this.loading = false;
      this.headerFocus();
    });
  }
  
  orderList(data: RadioModel[], selectedItem: string): RadioModel[] {
    if (selectedItem !== '') {
      const dataOrder = data;
      dataOrder.sort(ValueSort.compareFn);
      return [
        ...dataOrder.filter(value => value.key === selectedItem),
        ...dataOrder.filter(value => value.key !== selectedItem)
      ];
    }
    return data;
  }

  getPageId(): string {
    return this.headerId;
  }
  

  setEditPageRegistratio() {
    if (this.journeyService.registratioJourney.data.address?.state && this.journeyService.registratioJourney.data.address?.stateName) {
      this.selectedItem = this.journeyService.registratioJourney.data.address.state;
      this.selectedName = this.journeyService.registratioJourney.data.address.stateName;
    }
  }

  scrollContentToTop() {
    setTimeout(() => this.content?.nativeElement.scrollTo(0, 0), 200);
  }

  changeValue() {
    this.state = this.orderList(this.state, this.selectedItem);
  }

}
